import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { trigger, style, animate, transition, AnimationEvent } from '@angular/animations';

@Component({
    selector: 'app-support-article-popup',
    templateUrl: './support-article-popup.component.html',
    styleUrls: ['./support-article-popup.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateX(100%)', opacity: 0 }),
                animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 })),
            ]),
            transition(':leave', [
                style({ transform: 'translateX(0)', opacity: 1, position: 'fixed', right: 0 }),
                animate('300ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 })),
            ]),
        ]),
    ],
    standalone: false
})
export class SupportArticlePopupComponent implements OnInit, OnChanges {
  @Input() slug: string;
  @Output() closed = new EventEmitter<void>();

  private readonly sourceTag = 'V10';
  private readonly VALID_SLUG = /^[a-zA-Z0-9-_]+$/;
  isVisible = true;
  articleUrl: SafeResourceUrl | undefined;
  private fullUrl!: string;
  isClosing = false;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.loadArticle();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['slug'] && !changes['slug'].isFirstChange()) {
      this.loadArticle();
    }
  }

  private loadArticle() {
    if (!this.slug || !this.VALID_SLUG.test(this.slug)) {
      this.articleUrl = undefined;
      return;
    }
    this.fullUrl = `${environment.SUPPORT_ARTICLE_URL}article/${this.slug}`;
    const embedUrl = `${this.fullUrl}?embed=true`;
    this.articleUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);

  }

  onAnimationDone(event: AnimationEvent) {
    if (event.toState === 'void') {
      this.isClosing = false;
      this.closed.emit();
    }
  }

  openFullPage() {
    if (!this.fullUrl) return;
    const url = `${this.fullUrl}?from=${this.sourceTag}`;
    window.open(url, '_blank');
  }

  close() {
    if (this.isClosing) return;
    this.isClosing = true;
    this.isVisible = false;
  }
}
